var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPellSocialTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12.4298 8.85893C11.2626 9.34456 8.93007 10.3491 5.43179 11.8735C4.86367 12.0994 4.56601 12.3202 4.53929 12.5363C4.49347 12.9016 4.95117 13.0456 5.57429 13.2415C5.65872 13.2681 5.74619 13.2956 5.83586 13.3247C6.44851 13.5239 7.27257 13.7569 7.70101 13.7663C8.08961 13.7742 8.52367 13.6144 9.00273 13.2853C12.2713 11.0789 13.9584 9.96378 14.0643 9.93987C14.1388 9.923 14.2424 9.90143 14.3127 9.96378C14.383 10.0261 14.376 10.1442 14.3685 10.1761C14.3232 10.3688 12.5327 12.0336 11.6027 12.8984C11.3111 13.1695 11.1041 13.362 11.0619 13.4058C10.9678 13.5036 10.8718 13.5961 10.7796 13.685C10.2106 14.2336 9.78395 14.6449 10.8037 15.3169C11.2923 15.6389 11.6836 15.9053 12.0737 16.171C12.502 16.4627 12.9289 16.7534 13.4816 17.1155C13.6223 17.2077 13.7566 17.3034 13.8874 17.3967C14.3844 17.7512 14.831 18.0696 15.3824 18.0188C15.703 17.9892 16.0344 17.6878 16.2027 16.7883C16.6002 14.663 17.3816 10.0585 17.5621 8.16096C17.578 7.99456 17.5579 7.78221 17.542 7.68846C17.526 7.59518 17.4927 7.46206 17.3713 7.36362C17.2274 7.2469 17.0057 7.22253 16.9063 7.22393C16.4549 7.2319 15.7626 7.47284 12.4298 8.85893Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPellSocialTelegram);
export default __webpack_public_path__ + "static/media/pell_social_telegram.aebe76bb2fea2a080752c9acde9bd083.svg";
export { ForwardRef as ReactComponent };